import { Entry } from 'contentful';
import { getModule as getStoreModule } from 'vuex-module-decorators';
import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IOfferCSlideData from '@app/types/data/slides/IOfferCSlideData';
import AbstractOfferSlideTransform from '@app/transforms/slides/AbstractOfferSlideTransform';
import IConnectionNavigationItem from '@app/types/data/base/IConnectionNavigationItem';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import IFlatConnection from '@app/types/data/base/IFlatConnection';
import GlobalsStoreModule from '../../store/modules/GlobalsStoreModule';
import ILocation from '../../types/base/ILocation';

/**
 * Transform for 011-OfferCSlide
 */
export default class OfferCSlideTransform extends AbstractOfferSlideTransform {
	public viewComponent: string = 'OfferCSlide';

	public async transform(slide: ISlideMaster, presentationSettings: IPresentationSettings): Promise<IOfferCSlideData> {
		const globalsStore: GlobalsStoreModule = getStoreModule(GlobalsStoreModule);
		const {locations} = globalsStore;

		const data: IOfferCSlideData = {
			...(await super.transform(slide, presentationSettings)),
			connectionList: slide.fields.list.map(
				(item: Entry<any>): IConnectionNavigationItem => ({
					title: item.fields.title as IConnectionNavigationItem['title'],
					price: item.fields.price as IConnectionNavigationItem['price'],
					svgGroupId: item.fields.svgGroupId as IConnectionNavigationItem['svgGroupId'],
					connection: {
						id: (item.fields.connection as Entry).sys.id,
						type: (item.fields.connection as Entry).fields.type as IFlatConnection['type'],
						// eslint-disable-next-line
						stations: (((item.fields.connection as Entry).fields.stations as Entry[]).map((station): ILocation | undefined =>
							locations.find((location: ILocation): boolean => location.id === station.sys.id)
						) as (ILocation | undefined)[]).filter(
							(location: ILocation | undefined): boolean => !!location
						) as ILocation[]
					}
				})
			)
		};
		return data;
	}
}
